























import Vue from "vue";

export default Vue.extend({
  name: "App",
  data: () => ({
    name: "たくさん",
    id: "takusan_23",
    mastodonLink: "https://best-friends.chat/@takusan_23",
    githubLink: "https://github.com/takusan23",
    icon:
      "https://media.best-friends.chat/accounts/avatars/000/020/498/static/bc0bd14abb0bb063.png",
    blogLink: "https://takusan23.github.io/Bibouroku/"
  }),
  methods: {
    open(link: string): void {
      window.open(link);
    }
  }
});
